import styles from './ApprovedApplication.module.css';
import { displayCurrency } from '../../ANTCard/ANTCard';
import { ApprovedApplicationState } from '../../Dashboard.types';
import { OfferChoiceForm } from '../../OfferChoiceForm/OfferChoiceForm';

export const ApprovedApplication = ({
    application
}: {
    application: ApprovedApplicationState;
}) => {
    return (
        <div className={styles.newApprovedContainer}>
            <div className={styles.newApprovedText}>
                You've been{' '}
                <span className={styles.greenHighlight}>approved</span> for{' '}
                {displayCurrency(application.payLink.amount)}
            </div>
            <OfferChoiceForm payLink={application.payLink} />
        </div>
    );
};
